import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../helpers';

const CAMPOS_SECCION = `
    seccionCatID
    clave
    descripcion
    orden
    activa
    activaNombre
    preguntas
    fechaModificacion
`;

const CAMPOS_PREGUNTA = `
    preguntaCatID
    seccionCatID
    clave
    orden
    tipo
    tipoNombre
    texto
    obligatoria
    activa
    activaNombre
    etiquetaDetalle
    tipoDetalle
    valorDefault
    modoFilas
    aniosAtras
    incluyeProyeccion
    subfilas
    opciones
    fechaModificacion
`;

const CAMPOS_OPCION = `
    opcionCatID
    preguntaCatID
    tipoOpcion
    tipoOpcionNombre
    etiqueta
    tipoDato
    tipoDatoNombre
    muestraDetalle
    etiquetaEditable
    orden
    fechaModificacion
`;

const ejecutar = async ({ query, variables, campo, token }) => {
    try {
        let resultado = await FetchAPI.graphql({ token, variables, url: urlServidor, query });
        return resultado[campo];
    } catch ({ message }) { throw new Error(message); }
};

// En los formularios los valores nulos se manejan como cadena vacía
const sinNulos = (registro) => {
    if (!registro) return registro;
    let resultado = { ...registro };
    for (const [key, value] of Object.entries(resultado)) {
        if (value === null) resultado[key] = "";
    }
    return resultado;
};

//#region Secciones
export const getEncuestaCatSeccion = async (filtro, token) => sinNulos(await ejecutar({
    token, variables: { filtro }, campo: "getEncuestaCatSeccion",
    query: `query get($filtro: InputGetEncuestaCatSecciones){ getEncuestaCatSeccion(filtro: $filtro){ ${CAMPOS_SECCION} } }`
}));

export const getAllEncuestaCatSecciones = async (variables, token) => await ejecutar({
    token, variables, campo: "getAllEncuestaCatSecciones",
    query: `query getAll($filtro: InputGetEncuestaCatSecciones){ getAllEncuestaCatSecciones(filtro: $filtro){ ${CAMPOS_SECCION} } }`
});

export const tablaEncuestaCatSecciones = async (variables, token) => await ejecutar({
    token, variables, campo: "filterEncuestaCatSecciones",
    query: `query filtro($filtro: InputFiltroEncuestaCatSecciones){ filterEncuestaCatSecciones(filtro: $filtro){ listado{ ${CAMPOS_SECCION} } registros paginas } }`
});
//#endregion

//#region Preguntas
export const getEncuestaCatPregunta = async (filtro, token) => sinNulos(await ejecutar({
    token, variables: { filtro }, campo: "getEncuestaCatPregunta",
    query: `query get($filtro: InputGetEncuestaCatPreguntas){ getEncuestaCatPregunta(filtro: $filtro){ ${CAMPOS_PREGUNTA} } }`
}));

export const getAllEncuestaCatPreguntas = async (variables, token) => await ejecutar({
    token, variables, campo: "getAllEncuestaCatPreguntas",
    query: `query getAll($filtro: InputGetEncuestaCatPreguntas){ getAllEncuestaCatPreguntas(filtro: $filtro){ ${CAMPOS_PREGUNTA} } }`
});

export const tablaEncuestaCatPreguntas = async (variables, token) => await ejecutar({
    token, variables, campo: "filterEncuestaCatPreguntas",
    query: `query filtro($filtro: InputFiltroEncuestaCatPreguntas){ filterEncuestaCatPreguntas(filtro: $filtro){ listado{ ${CAMPOS_PREGUNTA} } registros paginas } }`
});
//#endregion

//#region Opciones
export const getEncuestaCatOpcion = async (filtro, token) => sinNulos(await ejecutar({
    token, variables: { filtro }, campo: "getEncuestaCatOpcion",
    query: `query get($filtro: InputGetEncuestaCatOpciones){ getEncuestaCatOpcion(filtro: $filtro){ ${CAMPOS_OPCION} } }`
}));

export const getAllEncuestaCatOpciones = async (variables, token) => await ejecutar({
    token, variables, campo: "getAllEncuestaCatOpciones",
    query: `query getAll($filtro: InputGetEncuestaCatOpciones){ getAllEncuestaCatOpciones(filtro: $filtro){ ${CAMPOS_OPCION} } }`
});

export const tablaEncuestaCatOpciones = async (variables, token) => await ejecutar({
    token, variables, campo: "filterEncuestaCatOpciones",
    query: `query filtro($filtro: InputFiltroEncuestaCatOpciones){ filterEncuestaCatOpciones(filtro: $filtro){ listado{ ${CAMPOS_OPCION} } registros paginas } }`
});
//#endregion
